<template>
  <transition name="dwp--fade">
    <i-frame id="dwp--wrapper" v-if="open">
      <SignIn v-if="!loggedIn" />
      <Tasks v-else-if="subscription" />
      <SubscriptionEnded v-else />
    </i-frame>
  </transition>
</template>

<script>
import store from "@/store";
import { sync, get } from "vuex-pathify";

export default {
  store,
  computed: {
    open: sync("ui/open"),
    signIn: sync("ui/modal@signIn"),
    loggedIn: get("user/user@loggedIn"),
    subscription: get("user/user@data.subscription"),
  },
  components: {
    SignIn: () => import("@/components/SignIn.vue"),
    SubscriptionEnded: () => import("@/components/SubscriptionEnded.vue"),
    SupportLinks: () => import("@/components/SupportLinks.vue"),
    iFrame: () => import("@/components/ui/iFrame.vue"),
    Tasks: () => import("./components/Tasks.vue"),
  },
};
</script>

<style>
#dwp--wrapper {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  width: 100% !important;
  height: 100% !important;
  z-index: 999999999 !important;
}
.dwp--fade-enter-active,
.dwp--fade-leave-active {
  transition: opacity 0.2s;
}
.dwp--fade-enter, .dwp--fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>